import { useEffect } from 'react';
import { Modal, TextInput, Select, PasswordInput } from '@mantine/core';
import { Controller, useForm } from 'react-hook-form';

import { ReactComponent as SettingsIllus } from 'assets/images/settingsimg.svg';
import { ReactComponent as EmailIllus } from 'assets/images/noemails.svg';
import { ReactComponent as DownArrow } from 'assets/icons/downArrow.svg';
import PrimaryButton from 'components/primaryButton';
export default function EmailSettings({ opened, setIsOpened }) {
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    reset();
  }, [reset]);
  // error message
  const getErrorMessage = (name) => {
    return (
      errors[name] && (
        <p className=' text-sm font-semibold text-red-500'>
          {errors[name]?.message}
        </p>
      )
    );
  };
  const emailHost = [
    { label: 'smtp.gmail.com', value: 'smtp.gmail.com' },
    { label: 'smtp.office365.com', value: 'smtp.office365.com' },
    { label: 'smtp-mail.outlook.com', value: 'smtp-mail.outlook.com' },
  ];
  const protocols = [
    { label: 'IMAP', value: 'IMAP' },
    { label: 'POP', value: 'POP', disabled: true },
  ];
  const ports = [{ label: '587', value: '587' }];
  const Submit = (data) => {
    delete data.email_port;
    delete data.email_server_name;
    delete data.email_host;
    // console.log(data);
  };
  return (
    <Modal
      opened={opened}
      onClose={() => setIsOpened(false)}
      centered
      transitionDuration={100}
      size={'xl'}
      overlayBlur={10}
      overlayOpacity={0.5}
      overlayColor={'#F8F7F799'}
      overflow='inside'
      classNames={{
        body: 'scroller h-auto',
      }}
    >
      <form
        onSubmit={handleSubmit(Submit)}
        className='flex w-full items-start justify-between flex-col px-4 gap-y-4 '
      >
        <div className='flex  justify-between w-full items-center'>
          <h1 className='text-18 font-semibold text-222222   '>
            Email Settings
          </h1>
          <div className='flex gap-x-4  justify-end'>
            <PrimaryButton>
              <button type='submit'>Save</button>
            </PrimaryButton>
            <PrimaryButton>Test Credentials</PrimaryButton>
            <PrimaryButton>Change to default</PrimaryButton>
          </div>
        </div>
        <div className='w-full flex   justify-between '>
          <div className='w-[40%] flex flex-col'>
            <EmailIllus className='w-[70%] self-center ' />
            <SettingsIllus className='w-[40%] pt-12 ' />
          </div>
          <div className='w-[55%] flex flex-col gap-y-4'>
            <div>
              <Controller
                name='email_user'
                control={control}
                rules={{ required: 'This is a required field' }}
                render={({ field }) => (
                  <TextInput
                    {...field}
                    placeholder='Email'
                    label='User email'
                    size='md'
                    classNames={{
                      input:
                        'bg-transparent border-primary text-sm  2xl:text-lg 3xl:text-xl',
                      placeholder: 'text-8E8E8E text-sm ',
                      label:
                        'text-[#8E8E8E] text-sm font-normal bg-[#FDFCFC]  ',
                    }}
                  />
                )}
              />
              {getErrorMessage('email_user')}
            </div>
            <div>
              <Controller
                name='email_password'
                control={control}
                rules={{ required: 'This is a required field' }}
                render={({ field }) => (
                  <PasswordInput
                    {...field}
                    placeholder='password'
                    label='Email password'
                    size='md'
                    classNames={{
                      input:
                        'bg-transparent border-primary text-sm  2xl:text-lg 3xl:text-xl',
                      placeholder: 'text-8E8E8E text-sm ',
                      label:
                        'text-[#8E8E8E] text-sm font-normal bg-[#FDFCFC]  ',
                    }}
                  />
                )}
              />
              {getErrorMessage('email_password')}
            </div>
            <div>
              <Controller
                name='email_host'
                control={control}
                rules={
                  {
                    /* required: 'This is a required field', */
                  }
                }
                render={({ field }) => (
                  <Select
                    {...field}
                    size='md'
                    label='Email host'
                    disabled
                    data={emailHost}
                    rightSection={<DownArrow />}
                    classNames={{
                      input: 'border-primary',
                      label:
                        'text-[#8E8E8E] text-sm font-normal bg-[#FDFCFC]  ',
                    }}
                  />
                )}
              />
              {getErrorMessage('email_host')}
            </div>
            <div>
              <Controller
                name='email_server_name'
                control={control}
                rules={
                  {
                    /* required: 'This is a required field', */
                  }
                }
                render={({ field }) => (
                  <Select
                    {...field}
                    size='md'
                    label='Email server protocol'
                    data={protocols}
                    disabled
                    rightSection={<DownArrow />}
                    classNames={{
                      input: 'border-primary',
                      label:
                        'text-[#8E8E8E] text-sm font-normal bg-[#FDFCFC]  ',
                    }}
                  />
                )}
              />
              {getErrorMessage('email_server_name')}
            </div>
            <div>
              <Controller
                name='email_port'
                control={control}
                rules={
                  {
                    /* required: 'This is a required field', */
                  }
                }
                render={({ field }) => (
                  <Select
                    {...field}
                    size='md'
                    disabled
                    label='SMTP port'
                    data={ports}
                    rightSection={<DownArrow />}
                    classNames={{
                      input: 'border-primary',
                      label:
                        'text-[#8E8E8E] text-sm font-normal bg-[#FDFCFC]  ',
                    }}
                  />
                )}
              />
              {getErrorMessage('email_port')}
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
}
